import { render, staticRenderFns } from "./BaseMitCsailMultiUsers.vue?vue&type=template&id=8ef0b38c&scoped=true"
import script from "./BaseMitCsailMultiUsers.vue?vue&type=script&lang=js"
export * from "./BaseMitCsailMultiUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef0b38c",
  null
  
)

export default component.exports